function Hud({
  gameTitle = 'Arcade Shooter',
  instructions = 'Arrow keys, WASD, or touch. Shooting is automatic.',
  levelName,
  levelIndex,
  levelCount,
  score,
  enemiesDefeated,
  enemyCount,
  levelGoal,
  levelDurationMs,
  levelElapsedMs,
  lives,
  bossHealth,
  bossMaxHealth,
  rapidFireMs = 0,
  spreadShotMs = 0,
  optionDroneMs = 0,
}) {
  const remainingSeconds = Math.max(
    0,
    Math.ceil(((levelDurationMs ?? 0) - (levelElapsedMs ?? 0)) / 1000)
  );
  const activePowerups = [
    { label: 'RF', name: 'Rapid fire', remainingMs: rapidFireMs, maxMs: 12000 },
    { label: 'SP', name: 'Spread shot', remainingMs: spreadShotMs, maxMs: 12000 },
    { label: 'OD', name: 'Option drone', remainingMs: optionDroneMs, maxMs: 18000 },
  ].filter((powerup) => powerup.remainingMs > 0);

  return (
    <header className="hud">
      <div className="hud-title">
        <h1 id="app-title">{gameTitle}</h1>
        <p>{levelName}. {instructions}</p>
      </div>
      {activePowerups.length > 0 && (
        <div className="powerup-timers" aria-label="Active powerups">
          {activePowerups.map((powerup) => (
            <span
              className="powerup-timer"
              key={powerup.label}
              title={powerup.name}
              style={{
                '--powerup-progress': `${Math.max(4, Math.min(100, (powerup.remainingMs / powerup.maxMs) * 100))}%`,
              }}
            >
              <span>{powerup.label}</span>
              <strong>{Math.ceil(powerup.remainingMs / 1000)}s</strong>
              <i aria-hidden="true" />
            </span>
          ))}
        </div>
      )}
      <div className="hud-stats" aria-live="polite">
        <div className="score-panel">
          <span>Level</span>
          <strong>{levelIndex + 1}/{levelCount}</strong>
        </div>
        {levelGoal === 'boss' ? (
          <div className="score-panel">
            <span>Boss</span>
            <strong>{bossHealth ?? 0}/{bossMaxHealth ?? 0}</strong>
          </div>
        ) : levelGoal === 'survive' ? (
          <div className="score-panel">
            <span>Survive</span>
            <strong>{remainingSeconds}s</strong>
          </div>
        ) : levelGoal === 'challenge' ? (
          <div className="score-panel">
            <span>Hits</span>
            <strong>{enemiesDefeated}/{enemyCount}</strong>
          </div>
        ) : (
          <div className="score-panel">
            <span>Cleared</span>
            <strong>{enemiesDefeated}/{enemyCount}</strong>
          </div>
        )}
        <div className="score-panel">
          <span>Lives</span>
          <strong>{lives}</strong>
        </div>
        <div className="score-panel">
          <span>Score</span>
          <strong>{score}</strong>
        </div>
      </div>
    </header>
  );
}

export default Hud;
